import { Component, OnInit } from '@angular/core';
import { SharedService } from './services/SharedService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  
  title = 'Analysis on Demand';
  userName: string = '';
  isAdmin: boolean = false;

  constructor(public sharedsvc: SharedService){

  }

  ngOnInit(): void {
    this.sharedsvc.userName.subscribe(userName => this.userName = userName);
  }
}
